import styled from "@emotion/styled";
import { STRIPE_LOGO_BOX_GRADIENT } from "../theme";

const LogoBox = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${STRIPE_LOGO_BOX_GRADIENT};
`;

const StripeLogoBox = () => (
  <LogoBox>
    <svg
      width="49"
      height="20"
      viewBox="0 0 49 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15259_57621)">
        <path
          d="M0 7.56333C0.0971251 7.38755 0.0871737 7.17114 0.138921 6.97818C0.897213 4.14302 4.40048 3.89146 6.84135 4.46333C7.22268 4.55279 7.65258 4.67388 7.99411 4.85357V7.95318C6.95638 7.49185 5.78451 7.09263 4.62658 7.11021C4.16165 7.11724 3.49093 7.1938 3.45829 7.77896C3.42565 8.36411 4.12981 8.59107 4.56368 8.76177C6.36448 9.47114 8.3639 9.79653 8.6298 12.1055C9.01034 15.4071 5.91906 16.577 3.08253 16.3348C2.1061 16.2512 1.03932 15.9895 0.158823 15.5751V12.4368C0.993542 12.8075 1.83662 13.1778 2.74339 13.354C3.46068 13.493 5.2559 13.754 5.17191 12.611C5.13648 12.1305 4.60667 11.8907 4.21459 11.7172C3.10721 11.227 1.86568 11.0153 0.935824 10.1751C0.386908 9.67896 0.164396 9.08091 0 8.38286V7.56411L0 7.56333Z"
          fill="white"
        />
        <path
          d="M26.5279 0L26.5239 2.72539L23.1074 3.43086V0.701953L26.4085 0H26.5279Z"
          fill="white"
        />
        <path
          d="M31.1815 19.2982L27.8008 20.0002V4.44433H30.7838L30.943 5.22402L31.607 4.76386C34.0665 3.38691 36.6336 4.72441 37.6717 7.108C38.5578 9.14277 38.4575 12.3236 37.2991 14.2416C36.0357 16.3334 33.3094 17.0725 31.2631 15.5721L31.1818 15.6139V19.2982H31.1815ZM32.5257 7.18495C32.0114 7.23534 31.5055 7.45527 31.1898 7.86386L31.2193 12.6924C31.3757 13.0705 31.892 13.2885 32.286 13.3619C35.7539 14.0068 35.7408 6.87089 32.5257 7.18495Z"
          fill="white"
        />
        <path
          d="M48.9214 11.54H42.2795C42.3866 12.3595 42.7516 12.9966 43.5529 13.313C44.5552 13.7091 46.1454 13.5341 47.1716 13.2357C47.5545 13.1244 47.906 12.9435 48.2853 12.8263V15.4579C47.5445 15.9095 46.5848 16.1904 45.7147 16.2912C41.6474 16.7626 39.0389 14.747 38.8594 10.7013C38.7006 7.12279 40.9576 3.55443 45.032 4.29975C48.3446 4.906 49.3039 8.70092 48.9218 11.5396L48.9214 11.54ZM45.7796 9.04467C45.7203 8.49818 45.661 7.98764 45.3015 7.54467C44.4771 6.52865 42.9188 6.85912 42.4483 8.02084C42.3086 8.36615 42.2894 8.68842 42.2397 9.04467H45.7796Z"
          fill="white"
        />
        <path
          d="M12.6481 1.55859V4.38516L12.7078 4.44375H15.2334V7.28984H12.6481V12.1828C12.6481 12.2559 12.7197 12.5426 12.7476 12.6312C13.0656 13.6492 14.4226 13.4738 15.2334 13.216V15.9449C14.7179 16.1406 14.1754 16.282 13.6221 16.3344C11.3269 16.5508 9.44571 15.4238 9.3052 13.0426C9.15394 10.4812 9.42382 7.77891 9.3052 5.20234C9.39834 4.21641 9.32072 3.21484 9.34898 2.22344L12.6481 1.55898V1.55859Z"
          fill="white"
        />
        <path
          d="M22.3125 7.48577C21.3667 7.29475 20.3704 7.39866 19.7271 8.16819V16.0826L19.6674 16.1326C19.6511 16.1338 19.6376 16.1022 19.6276 16.1022H16.3066V4.44475H19.2498L19.4493 5.3803C19.6177 5.20725 19.7227 4.99866 19.9074 4.83577C20.5419 4.276 21.5406 4.15921 22.3125 4.46428V7.48577Z"
          fill="white"
        />
        <path
          d="M26.5279 4.44434V16.1014H23.2069C23.193 16.1014 23.1628 16.1705 23.1074 16.0818V4.44434H26.5279Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_15259_57621">
          <rect width="49" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </LogoBox>
);

export default StripeLogoBox;
